import { render, staticRenderFns } from "./GlobalSearchHeader.vue?vue&type=template&id=65ba0064&scoped=true&"
import script from "./GlobalSearchHeader.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearchHeader.vue?vue&type=style&index=0&id=65ba0064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba0064",
  null
  
)

export default component.exports